import React, { useState, useEffect, useContext } from "react";
import Papa from "papaparse";
import { motion } from "framer-motion";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "bootstrap/dist/css/bootstrap.min.css";
import ProgressBar from "react-bootstrap/ProgressBar";
import {
  CircularProgressbar,
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";

import "react-circular-progressbar/dist/styles.css";
import "./App.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ModalHitos from "./ModalHitos";
import { Button } from "react-bootstrap";
import { NavLink, useParams, useHistory } from "react-router-dom";
import { AppContext } from "./provider/provider";

function Areas() {
  const [state] = useContext(AppContext);
  const datos = state.periodos[state.periodoActivo] || {};
  const areasData = datos.Areas || [];
  const iniciativasData = datos.Iniciativas || [];
  const hitosData = datos.Hitos || [];
  const avanceGeneral = datos.AvanceGeneral || 0;

  const compromisosMayor40 = iniciativasData.reduce((count, areaObj) => {
    return count + areaObj.Iniciativas.filter(
      (ini) => Number(ini.Avance?.replace("%", "") || 0) > 40
    ).length;
  }, 0);

  const [listaAreas, setListaAreas] = useState([]);
  const [listaIniciativas, setListaIniciativas] = useState([]);
  const [listaHitos, setListaHitos] = useState([]);
  const [progress, setProgress] = useState(0);
  const [porcentajeTotal, setPorcentajeTotal] = useState(0);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [informacionModal, setInformacionModal] = useState({});
  const [area, setArea] = useState("");
  const [areas, setAreas] = useState([]);

  let history = useHistory();

  useEffect(() => {
    window.parent.postMessage("scrollToTop", "*");
    createArrays();
    setProgress(0); // Reinicia progreso cada vez que cambia de período
  }, [state.periodoActivo]); // ⚠️ se recarga al cambiar período

  useEffect(() => {
    let interval;
    if (progress < avanceGeneral) {
      interval = setInterval(() => {
        setProgress((prev) => {
          const next = prev + 1;
          if (next >= avanceGeneral) {
            clearInterval(interval);
            return avanceGeneral;
          }
          return next;
        });
      }, 20);
    }

    return () => clearInterval(interval);
  }, [progress, avanceGeneral]);

  const createArrays = () => {
    let Periodo = state.periodoActivo;

    let baseAreas = [];

    if (Periodo.includes("2024")) {
      baseAreas = [
        {
          nombre: "Apoyo al Adulto Mayor",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/AdultoMayor.png",
        },
        {
          nombre: "Apoyo a niños, niñas y jóvenes",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/NinosNinasJovenes.png",
        },
        {
          nombre: "Mujer y Equidad de Género",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/MujerEquidadGenero.png",
        },
        {
          nombre: " Salud",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Salud.png",
        },
        {
          nombre: "Inclusión y Discapacidad",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/InclusionDiscapacidad.png",
        },
        {
          nombre: "Vivienda",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Vivienda.png",
        },
        {
          nombre: "Deporte",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Deporte.png",
        },
        {
          nombre: "Cultura",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Cultura.png",
        },
        {
          nombre: "Fomento productivo y emprendimiento",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/FomentoProductivo.png",
        },
        {
          nombre: "Seguridad Comunitaria",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/SeguridadComunitaria.png",
        },
        {
          nombre: "Medio Ambiente y cambio climático",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/MedioAmbiente.png",
        },
        {
          nombre: "Cuidado y protección animal",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/CuidadoProteccionAnimal.png",
        },
        {
          nombre: "Socializar la infraestructura y servicios municipales",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/SocializarInfraestructura.png",
        },
        {
          nombre: "Gobernanza colaborativa y participación",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/GobernanzaColaborativa.png",
        },
        {
          nombre: "Ciudad y Espacios públicos",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/CiudadEspaciosPublicos.png",
        },
        {
          nombre: "Transparencia y modernización municipal",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/TransparenciaModernizacion.png",
        },
      ];
    }
    if (Periodo.includes("2025")) {
      baseAreas = [
        {
          nombre: "Apoyo al Adulto Mayor",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/AdultoMayor.png",
        },
        {
          nombre: "Apoyo a niños, niñas y jóvenes",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/NinosNinasJovenes.png",
        },
        {
          nombre: "Mujer y Equidad de Género",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/MujerEquidadGenero.png",
        },
        {
          nombre: " Salud",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Salud.png",
        },
        {
          nombre: "Inclusión y Discapacidad",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/InclusionDiscapacidad.png",
        },
        {
          nombre: "Vivienda",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Vivienda.png",
        },
        {
          nombre: "Deporte",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Deporte.png",
        },
        {
          nombre: "Cultura",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/Cultura.png",
        },
        {
          nombre: "Fomento productivo y emprendimiento",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/FomentoProductivo.png",
        },
        {
          nombre: "Seguridad Comunitaria",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/SeguridadComunitaria.png",
        },
        {
          nombre: "Medio Ambiente y cambio climático",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/MedioAmbiente.png",
        },
        {
          nombre: "Cuidado y protección animal",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/CuidadoProteccionAnimal.png",
        },
        {
          nombre: "Socializar la infraestructura y servicios municipales",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/SocializarInfraestructura.png",
        },
        {
          nombre: "Gobernanza colaborativa y participación",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/GobernanzaColaborativa.png",
        },
        {
          nombre: "Ciudad y Espacios públicos",
          porcentaje: 0,
          width: "75px",
          src: process.env.PUBLIC_URL + "/img/CiudadEspaciosPublicos.png",
        },
      ];
    }

    // const baseAreas = [
    //   {
    //     nombre: "Apoyo al Adulto Mayor",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/AdultoMayor.png",
    //   },
    //   {
    //     nombre: "Apoyo a niños, niñas y jóvenes",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/NinosNinasJovenes.png",
    //   },
    //   {
    //     nombre: "Mujer y Equidad de Género",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/MujerEquidadGenero.png",
    //   },
    //   {
    //     nombre: " Salud",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/Salud.png",
    //   },
    //   {
    //     nombre: "Inclusión y Discapacidad",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/InclusionDiscapacidad.png",
    //   },
    //   {
    //     nombre: "Vivienda",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/Vivienda.png",
    //   },
    //   {
    //     nombre: "Deporte",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/Deporte.png",
    //   },
    //   {
    //     nombre: "Cultura",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/Cultura.png",
    //   },
    //   {
    //     nombre: "Fomento productivo y emprendimiento",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/FomentoProductivo.png",
    //   },
    //   {
    //     nombre: "Seguridad Comunitaria",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/SeguridadComunitaria.png",
    //   },
    //   {
    //     nombre: "Medio Ambiente y cambio climático",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/MedioAmbiente.png",
    //   },
    //   {
    //     nombre: "Cuidado y protección animal",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/CuidadoProteccionAnimal.png",
    //   },
    //   {
    //     nombre: "Socializar la infraestructura y servicios municipales",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/SocializarInfraestructura.png",
    //   },
    //   {
    //     nombre: "Gobernanza colaborativa y participación",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/GobernanzaColaborativa.png",
    //   },
    //   {
    //     nombre: "Ciudad y Espacios públicos",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/CiudadEspaciosPublicos.png",
    //   },
    //   {
    //     nombre: "Transparencia y modernización municipal",
    //     porcentaje: 0,
    //     width: "75px",
    //     src: process.env.PUBLIC_URL + "/img/TransparenciaModernizacion.png",
    //   },
    // ];

    baseAreas.forEach((area) => {
      if (Array.isArray(areasData)) {
        const registro = areasData.find((init) =>
          init.Area?.includes(area.nombre)
        );
        if (registro) {
          area.porcentaje = Number(registro.Avance?.replace("%", "") || 0);
        }
      }
    });
    setAreas(baseAreas);
    setListaAreas(areasData);
    setListaIniciativas(iniciativasData);
    setListaHitos(hitosData);
    //PorcentajeTotal(avanceGeneral);
  };

  const columns = [
    {
      dataField: "id",
      text: "Product ID",
      hidden: true,
    },
    {
      dataField: "Areas",
      text: "ÁREAS",
      headerClasses: "headerTabla",
      classes: "agrupacion",
      headerStyle: {
        width: "250px",
        minWidth: "250px",
        color: "#fff",
      },
      formatter: (cell, row) => {
        return (
          <Row>
            <Col md={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "#5d428b",
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  ></div>
                  <div>{row.Areas}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "#5d428b",
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span className="iniciativas">
                    {row.Iniciativas.length} Iniciativas
                  </span>
                </div>
              </div>
            </Col>
            <Col md={6} style={{ paddingTop: "15px", paddingBottom: "15px" }}>
              <div style={{ paddingTop: "10px" }}>
                <ProgressBar variant="warning" now={row.barra} />
              </div>
            </Col>
            <Col
              md={2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "0px",
              }}
            >
              {row.Avance}
            </Col>
          </Row>
        );
      },
    },
    // {
    //   dataField: "barra",
    //   text: "",

    //   headerClasses: "headerTabla",
    //   classes: "agrupacion",
    //   formatter: priceFormatter,
    // },

    // {
    //   dataField: "Avance",
    //   text: "AVANCE DEL ÁREA",
    //   align: "center",
    //   headerStyle: {
    //     width: "180px",
    //     minWidth: "180px",
    //   },
    //   headerClasses: "headerTabla",
    //   classes: "agrupacion",
    // },
  ];

  const percentage = 66;

  function handleClick() {
    history.push("/Contenido"); // Reemplaza '/otra-ruta' con la ruta de tu otro componente
  }

  const PorcentajeTotal = (avance) => {
    const interval = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= avance ? avance : prevProgress + 1
      );
    }, 50);
    return () => clearInterval(interval);
  };
  return (
    <Container
      fluid
      style={{ backgroundColor: "transparent", padding: "0px 20px 20px 20px" }}
    >
      <motion.div
        className="modern-container"
        style={{ margin: "15px 0", padding: "0" }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Row
          className="header-gradient"
          style={{
            color: "#fff",
            textTransform: "uppercase",
            padding: "20px 0px 20px 0px",
            textAlign: "center",
            marginBottom: "0px",
            margin: "0",
            borderRadius: "20px 20px 0 0",
          }}
        >
          <motion.h4
            style={{ margin: "0", textShadow: "0 2px 4px rgba(0,0,0,0.3)" }}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Resumen Global de Avance
          </motion.h4>
        </Row>
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "20px 20px",
          }}
        >
          <Col
            md={3}
            className="progress-item"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <motion.div
              className="progress-circle-container animated-progress"
              style={{ width: 120, height: 120 }}
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{
                duration: 0.8,
                delay: 0.4,
                type: "spring",
                stiffness: 200,
              }}
            >
              <CircularProgressbar
                value={progress}
                text={`${progress}%`}
                strokeWidth={12}
                styles={buildStyles({
                  pathColor: `rgba(93, 66, 139, 0.85)`,
                  textColor: "#81ba27",
                  trailColor: "rgba(93, 66, 139, 0.1)",
                  backgroundColor: "#3e98c7",
                  textSize: "28px",
                  textWeight: "bold",
                  strokeLinecap: "round",
                  paddingBottom: "20px",
                  text: {
                    fontWeight: "bold",
                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
                  },
                  pathTransition:
                    progress === 0 ? "none" : "stroke-dashoffset 0.8s ease 0s",
                })}
              />
            </motion.div>
            <motion.div
              className="progress-label"
              style={{ marginTop: "15px" }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <span
                style={{
                  fontWeight: "700",
                  textAlign: "center",
                  color: "#3d2e66",
                }}
              >
                AVANCE PROMEDIO DE CUMPLIMIENTO
              </span>
            </motion.div>
          </Col>
        </Row>
        <Row className="progress-summary" style={{ padding: "15px 0 20px 0", margin: "0", borderRadius: "0 0 20px 20px" }}>
          {state.periodoActivo.includes("2024") ? (
            <motion.div
              className="col-md-3 progress-item"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            >
              <div
                className="progress-value"
                style={{
                  color: "#81ba27",
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                95
              </div>
              <div className="progress-label" style={{ color: "#3d2e66" }}>
                COMPROMISOS <span style={{ fontWeight: "700" }}>ASUMIDOS</span>
              </div>
            </motion.div>
          ) : (
            <motion.div
              className="col-md-3 progress-item"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            >
              <div
                className="progress-value"
                style={{
                  color: "#81ba27",
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                109
              </div>
              <div className="progress-label" style={{ color: "#3d2e66" }}>
                COMPROMISOS <span style={{ fontWeight: "700" }}>ASUMIDOS</span>
              </div>
            </motion.div>
          )}

          {state.periodoActivo.includes("2024") ? (
            <motion.div
              className="col-md-3 progress-item"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 1.0 }}
            >
              <div
                className="progress-value"
                style={{
                  color: "#81ba27",
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                84
              </div>
              <div className="progress-label" style={{ color: "#3d2e66" }}>
                COMPROMISOS{" "}
                <span style={{ fontWeight: "700" }}>
                  EN AVANCE MAYOR AL 80%
                </span>
              </div>
            </motion.div>
          ) : (
            <motion.div
              className="col-md-3 progress-item"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 1.0 }}
            >
              <div
                className="progress-value"
                style={{
                  color: "#81ba27",
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                {compromisosMayor40}
              </div>
              <div className="progress-label" style={{ color: "#3d2e66" }}>
                COMPROMISOS{" "}
                <span style={{ fontWeight: "700" }}>
                  EN AVANCE MAYOR AL 40%
                </span>
              </div>
            </motion.div>
          )}
        </Row>
      </motion.div>
      <motion.div
        className="modern-container"
        style={{ margin: "15px 0", padding: "0" }}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.6 }}
      >
        <Row
          className="header-gradient-orange"
          style={{
            color: "#fff",
            textTransform: "uppercase",
            padding: "20px 0px 20px 0px",
            textAlign: "center",
            marginBottom: "0px",
            margin: "0",
            borderRadius: "20px 20px 0 0",
          }}
        >
          <motion.h4
            style={{
              marginBottom: "0px",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: 0.7 }}
          >
            Avance por Áreas
          </motion.h4>
        </Row>
        <Row
          style={{
            marginTop: "5px",
            display: "flex",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          {areas.map((area, i) => {
            return (
              <Col
                md={4}
                key={i}
                style={{
                  marginTop: "10px",
                  marginBottom: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <motion.div
                  className="area-card"
                  style={{ width: "100%", maxWidth: "380px" }}
                  initial={{ opacity: 0, y: 50, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  transition={{
                    duration: 0.2, // Reducido de 0.4 a 0.2 (50% más rápido)
                    delay: 0.1 + i * 0.02, // Reducido de 0.8 + i * 0.05 a 0.1 + i * 0.02
                    type: "spring",
                    stiffness: 200, // Aumentado de 120 a 200 para movimiento más rápido
                  }}
                  whileHover={{
                    y: -10,
                    scale: 1.02,
                    transition: { duration: 0.15 }, // Reducido de 0.2 a 0.15
                  }}
                >
                  <Row>
                    <Col
                      md={12}
                      style={{
                        marginBottom: "20px",
                        textAlign: "center",
                      }}
                    >
                      <span
                        style={{
                          textTransform: "uppercase",
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#5d428b",
                          letterSpacing: "1px",
                          lineHeight: "1.3",
                          textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        {area.nombre}
                      </span>
                    </Col>
                    <Col
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="progress-circle-container"
                        style={{ width: 150, height: 150, padding: "0px" }}
                      >
                        <CircularProgressbarWithChildren
                          value={area.porcentaje}
                          style={{ width: 500 }}
                          strokeWidth={8}
                          background
                          styles={buildStyles({
                            strokeLinecap: "round",
                            textSize: "16px",
                            pathTransitionDuration: 0.4, // Reducido de 0.8 a 0.4
                            pathColor: `#81ba27`,
                            textColor: "#f88",
                            trailColor: "#d6d6d6",
                            backgroundColor: "#5D428B",
                          })}
                        >
                          <img
                            style={{
                              width: area.width
                                ? parseInt(area.width) + 20 + "px"
                                : "60px",
                              margin: "10px",
                              paddingBottom: "2px",
                              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
                            }}
                            src={area.src}
                            alt="imagen"
                          />
                          <div style={{ fontSize: 12, marginTop: -5 }}></div>
                        </CircularProgressbarWithChildren>
                      </div>
                    </Col>
                    <Col
                      md={12}
                      style={{
                        justifyContent: "center",
                        textAlign: "center",
                        marginTop: "15px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "1.8rem",
                          fontWeight: "700",
                          color: "#263238",
                          textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        {area.porcentaje + "%"}
                      </span>
                      <p
                        style={{
                          fontSize: "14px",
                          marginBottom: "15px",
                          color: "#666",
                        }}
                      >
                        de avance
                      </p>
                      <NavLink
                        to={{
                          pathname: `/Contenido/${area.nombre}`,
                          state: {
                            NombreArea: area.nombre,
                            ListaAreas: listaAreas,
                            ListaIniciativas: listaIniciativas,
                            ListaHitos: listaHitos,
                          },
                        }}
                      >
                        <motion.div
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          <Button
                            className="btn-modern"
                            style={{
                              width: "120px",
                              fontSize: "14px",
                            }}
                          >
                            Ver más
                          </Button>
                        </motion.div>
                      </NavLink>
                    </Col>
                  </Row>
                </motion.div>
              </Col>
            );
          })}
        </Row>
      </motion.div>
      {Object.keys(informacionModal).length > 0 && (
        <ModalHitos
          MostrarModal={mostrarModal}
          InformacionModal={informacionModal}
          Area={area}
          CerrarModal={() => {
            setMostrarModal(false);
            setArea("");
            setInformacionModal({});
          }}
        />
      )}
    </Container>
  );
}

export default Areas;
